import { Icon } from "@/components/icon/Icon";

const REFUSALS = [
  {
    title: "대신 올리지 않아요",
    body: "텔뷰는 어떤 플랫폼에도 후기를 올리지 않아요. 올리는 사람은 언제나 손님 본인이에요.",
  },
  {
    title: "좋은 후기만 골라 받지 않아요",
    body: "별점을 먼저 묻고 만족한 손님만 보내는 일은 하지 않아요. 아쉬웠던 손님도 같은 화면에서 같은 곳으로 가요.",
  },
  {
    title: "후기에 대가를 걸지 않아요",
    body: "할인, 적립, 경품을 후기와 엮는 기능이 없어요. 제품을 제공받은 경우에는 그 사실이 초안에 붙어요.",
  },
  {
    title: "없던 일을 쓰지 않아요",
    body: "초안에는 손님이 고른 사실만 들어가요. 아쉬운 점을 고르면 빼지 않고 그대로 넣어요.",
  },
];

/** What Tellvue refuses to do, in plain sentences. Tinted band, same theme. */
export function Principles() {
  return (
    <section aria-labelledby="principles-title" className="bg-background-alternative">
      <div className="mx-auto max-w-layout px-5 py-20">
        <p className="text-label-1 font-semibold text-primary-normal">텔뷰의 원칙</p>
        <h2
          id="principles-title"
          className="mt-2 max-w-2xl wds-title-2 text-label-strong break-keep"
        >
          손님의 후기는 손님 것이라서, 이런 일은 하지 않아요
        </h2>
        <dl className="mt-12 grid gap-x-16 gap-y-10 md:grid-cols-2">
          {REFUSALS.map((r) => (
            <div key={r.title} className="flex gap-4">
              <Icon
                name="circleClose"
                size={24}
                style={{ color: "var(--label-normal)", flex: "none", marginTop: 3 }}
              />
              <div className="min-w-0">
                <dt className="wds-headline-1 text-label-strong">{r.title}</dt>
                <dd className="mt-2 text-body-1 font-regular text-label-neutral break-keep">
                  {r.body}
                </dd>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
